module.exports = __webpack_public_path__ + "img/EDT_LOGO_S.a9c1c014.png";